import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import SEO from '../components/Seo';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import DokumenteSlider from '../components/DokumenteSlider';
import Header_2 from '../headers/Header_2';
import Button from '../components/Button';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import FaqMoldule from '../modules/FaqModule';
import MedienPopupSlider from '../components/MedienPopupSlider';
import ImageBeforeAfter from '../modules/ImageBeforeAfter';

export const VisionMissionLeitbild = () => {


    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/vision-mission-and-leitbild-page?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Video]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Video][populate]=*&populate[Modul][on][modules.schnellabspruenge-modul][populate][Schnellabspruenge][populate][Button][populate]=true&populate[Modul][on][modules.faq][populate][FAQ_Data][populate]=*&populate[Modul][on][modules.bild-info][populate][Bild_Info_Daten][populate][Bild][populate]=true&populate[Modul][on][modules.vorher-nachher-bild-und-text][populate][Vorher_Bild]=true&populate[Modul][on][modules.vorher-nachher-bild-und-text][populate][Nachbild]=true&populate[Modul][on][modules.bild-pdf][populate][PDF][populate][PDF][populate]=true&populate[Modul][on][modules.bild-pdf][populate][Bild][populate]=true&populate[Modul][on][modules.bild-pdf][populate][Button][populate]=true&populate[Modul][on][modules.link-tabs][populate][Tab_Data][populate][Icon][populate]=true&populate[Metadaten]=*");


            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);

                const bildInfoModule = data?.data?.Modul?.find(
                    (module) => module.__component === "modules.bild-info"
                );

                fetchImages([bildInfoModule]);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    const [imagesMap, setImagesMap] = useState({});

    const fetchImages = async (bildInfoData) => {
        try {

            console.log('Fetching images for bildInfoData', bildInfoData);

            const response = await fetch(
                `https://backend.bgzurlinden.ch/api/upload/files`
            );

            const data = await response.json();

            const mappedImages = {};

            bildInfoData?.forEach((item) => {

                const imageId = item?.Bild?.image;

                const matchedImage = data.find(
                    (img) => img.documentId === imageId
                );

                if (matchedImage) {
                    mappedImages[imageId] = matchedImage;
                }
            });

            setImagesMap(mappedImages);

        } catch (err) {
            console.log(err);
        }
    };

    const [popupData, setPopupData] = useState(null);
    const [popupColor, setPopupColor] = useState(null);
    const [show, setShow] = useState(false);

    const showPopup = (infoData, color) => {
        setPopupData(infoData);
        setPopupColor(color);
        setShow(true);
    };

    const closePopup = () => {
        setPopupData(null);
        setShow(false);
    };

    const scrollToSection = (moduleIndex) => {
        const element = document.getElementById(
            `link-tab-${moduleIndex}`
        );

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hoveredId, setHoveredId] = useState(null);

    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {show && popupData && (
                <div className="modal medien_modal show d-block">
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button className="btn-close" onClick={closePopup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" nighteye="disabled">
                                        <rect width="64" height="64" rx="32" fill={`var(--${popupColor})`} />
                                        <rect x="19.3203" y="21.1396" width="2.56" height="33.28" rx="1.28" transform="rotate(-45 19.3203 21.1396)" fill="white" />
                                        <rect x="42.8594" y="19.3301" width="2.56" height="33.28" rx="1.28" transform="rotate(45 42.8594 19.3301)" fill="white" />
                                    </svg>
                                </button>
                                <div className={`popup-container popup-${popupColor}`}>
                                    <div className='row'>
                                        <div className='col-lg-6 contnet-col'>
                                            <h2 className={`text-${popupColor} fs_50 fw-600`}>{popupData?.Titel}</h2>
                                            <h3 className="text-black fs_30 fw-600">{popupData?.Untertitel}</h3>
                                            {popupData?.Text && <BlocksRenderer content={popupData?.Text} />}
                                        </div>
                                        <div className='col-lg-6 image-col'>
                                            <MedienPopupSlider images={popupData?.Bild} showDownloadIcon={false} popupColor={popupColor} />
                                        </div>
                                        <div className='col-12 content-col mt-4 tick_list two_col'>
                                            {popupData?.Beschreibung && <BlocksRenderer content={popupData?.Beschreibung} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-genossenschaft" activePage='Nachhaltigkeit & Innovation' />
                        )}
                    </React.Fragment>
                ))
            )}


            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`} id={'link-tab-' + index}>
                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="orange" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} sectionId={'link-tab-' + index} index={index}/>
                        }
                        {module.__component === "modules.faq" &&
                            <FaqMoldule module={module} sectionColor="green" sectionId={'link-tab-' + index} />
                        }
                        {module.__component === "modules.vorher-nachher-bild-und-text" &&
                            <ImageBeforeAfter module={module} shortTitle={module?.Kurztitel} beforeImage={module?.Vorher_Bild} afterImage={module?.Nachbild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="green" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} sectionId={'link-tab-' + index} />
                        }
                        {module.__component === "modules.link-tabs" &&
                            <section className='pt-pb-10 sec-pink-color'>
                                <div className='container'>
                                    <div className='row default-grid-gap job-card-row link-tabs tabs-content'>
                                        {module?.Tab_Data?.map((item, index) => (
                                            <div key={index} className='col-6 col-md-4 col-lg-3 col-item mb-4' onClick={() => scrollToSection(index + 1)} style={{ cursor: 'pointer' }}>
                                                <div className="flip-card text-center position-relative hide_cursor" onMouseEnter={() => setHoveredId(item.id)} onMouseLeave={() => setHoveredId(null)} onMouseMove={mouseMove}>
                                                    <div className="flip-card-front">
                                                        <img src={`https://backend.bgzurlinden.ch${item.Icon?.url}`} alt={item?.Titel} />
                                                        <h4 lang='de' className='text-darkgrey fw-550 fs_24'>{item?.Titel}</h4>
                                                    </div>

                                                    {hoveredId === item.id && (
                                                        <div
                                                            className="video_image_cursor"
                                                            style={{
                                                                left: `${position.x}px`,
                                                                top: `${position.y}px`,
                                                            }}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 100 100" fill="none">
                                                                <circle cx="50" cy="50" r="50" fill={`var(--pink)`} fill-opacity="0.7" />
                                                                <path d="M63.0375 56.4002C63.0196 57.1678 62.3828 57.8046 61.6152 57.8225C60.8476 57.8404 60.2398 57.2327 60.2577 56.4651L60.6535 39.5095L43.6978 39.9051C42.9302 39.9231 42.3224 39.3153 42.3404 38.5477C42.3583 37.7801 42.9951 37.1433 43.7627 37.1254L62.1082 36.6973C62.8758 36.6794 63.4835 37.2872 63.4656 38.0548L63.0375 56.4002Z" fill="white" />
                                                                <path d="M38.8981 63.1845C38.3427 63.74 37.4626 63.7605 36.9325 63.2304C36.4024 62.7003 36.423 61.8202 36.9784 61.2648L61.1159 37.1273C61.6713 36.5719 62.5513 36.5513 63.0815 37.0815C63.6116 37.6116 63.591 38.4916 63.0356 39.047L38.8981 63.1845Z" fill="white" />
                                                            </svg>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.schnellabspruenge-modul" &&
                            <section className='pt-pb-10 sec-story-job sec-green-color' id={'link-tab-' + index}>
                                <div className='container'>
                                    <div className='row'>
                                        {module?.Schnellabspruenge?.map((item, index) => (
                                            <div key={index} className='col-lg-6 content-col mb-3 mb-lg-0'>
                                                <div className='col-inner fw_strong_500'>
                                                    <h2 className='text-black fw-500 mb-3'>{item?.Titel}</h2>
                                                    {item?.Text && <BlocksRenderer content={item?.Text} />}
                                                    <Button component={item?.Komponente} pdf={item?.PDF} buttons={item?.Button} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.bild-pdf" &&
                            <section className={`pt-pb-10 sec-bgz-dokumente ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`} id={'link-tab-' + index}>
                                {/* <section className='sec-bgz-dokumente'> */}
                                <div className="container">
                                    <div className={`row ${module?.Bildposition !== 'Rechts' ? 'flex-lg-row-reverse' : ''}`}>
                                        <div className="col-lg-6">
                                            <div className="col-inner">
                                                <h3 className={`text-${module?.Modul_Farbe} fw-550 mb-4`}>{module?.Titel}</h3>
                                                <div className='download_list'>
                                                    {module?.PDF?.map((item, index) => (
                                                        <a className={`fs_26 fw-450 ${index === module?.PDF?.length - 1 ? 'border-0' : ""} ${item?.button_farbe?.split(" ")[0]}`} key={index} href={`https://backend.bgzurlinden.ch${item?.PDF?.url}`} download target="_blank" rel="noopener noreferrer" >{item?.button_text}
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32" fill="none">
                                                                <path d="M11.9999 26.46C11.7285 26.46 11.4571 26.36 11.2439 26.155L2.01608 17.485C1.55566 17.055 1.52658 16.32 1.94338 15.845C2.36018 15.37 3.07262 15.34 3.53304 15.77L11.9999 23.735L20.4668 15.77C20.9272 15.34 21.6348 15.375 22.0565 15.845C22.4733 16.32 22.4393 17.05 21.9838 17.485L12.756 26.16C12.5427 26.36 12.2713 26.46 11.9999 26.46Z" fill={`var(--${item?.button_farbe?.split(" ")[0]})`} />
                                                                <path d="M11.9999 26.46C11.3796 26.46 10.8756 25.94 10.8756 25.3V1.16C10.8756 0.519999 11.3796 0 12 0C12.6203 0 13.1244 0.519999 13.1244 1.16V25.3C13.1244 25.945 12.6203 26.46 11.9999 26.46Z" fill={`var(--${item?.button_farbe?.split(" ")[0]})`} />
                                                                <path d="M22.8756 32H1.12439C0.504039 32 0 31.48 0 30.84C0 30.2 0.504039 29.68 1.12439 29.68H22.8756C23.496 29.68 24 30.2 24 30.84C24 31.48 23.496 32 22.8756 32Z" fill={`var(--${item?.button_farbe?.split(" ")[0]})`} />
                                                            </svg>
                                                        </a>
                                                    ))}
                                                </div>
                                                {module?.Komponente_Button && <Button component={module?.Komponente} pdf={module?.PDF} buttons={module?.Button} />}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mt-4 mt-lg-0 img_col">
                                            <img src={`https://backend.bgzurlinden.ch${module?.Bild[0]?.url}`} className='w-100' alt='BGZ Dokumente' />
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.bild-info" &&
                            <div className='multiple-locations-sec mt-10' id={'link-tab-' + index}>
                                <div className="container">
                                    {[module]?.map((item, index) => {

                                        const imageId = item?.Bild?.image;
                                        const image = imagesMap[imageId];

                                        return (
                                            <div key={index} className="hotspot-image-wrapper">

                                                <img
                                                    src={`https://backend.bgzurlinden.ch${image?.url}`}
                                                    alt=""
                                                    className="main-image"
                                                />

                                                {item?.Bild?.hotspots?.map((spot, i) => (
                                                    <button
                                                        key={spot.id}
                                                        className="hotspot-pin"
                                                        style={{
                                                            left: `${spot.x}%`,
                                                            top: `${spot.y}%`,
                                                            background: `var(--${item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0]})`,
                                                            animationName: `pulse-animation-${item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0]}`,
                                                        }}
                                                        onClick={() => showPopup(item?.Bild_Info_Daten[i], item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0])}
                                                    >
                                                        <img src="https://backend.bgzurlinden.ch/uploads/Group_1597881211_9751cd1a10.svg" alt="" />
                                                    </button>
                                                ))}

                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </div>
    )
}
